export default __webpack_public_path__ + "static/media/locked-disabled.1ab9aaea.svg";